import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCompass, FiArrowRight, FiActivity } = FiIcons;

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="max-w-xl w-full text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="mb-12 relative"
        >
          <div className="text-[12rem] font-black text-white/5 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 bg-gradient-to-tr from-indigo-500 to-blue-600 rounded-[2rem] flex items-center justify-center text-white text-4xl shadow-2xl shadow-indigo-500/20 rotate-12">
              <SafeIcon icon={FiActivity} className="w-12 h-12" />
            </div>
          </div>
        </motion.div>

        <h1 className="text-4xl font-black text-white mb-6 uppercase italic tracking-tighter">
          Lost in the flow?
        </h1>
        <p className="text-slate-400 text-lg font-medium mb-12 max-w-sm mx-auto">
          The page you're looking for was either shipped to another dimension or never existed.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/" 
            className="px-8 py-4 bg-white text-slate-950 rounded-2xl font-black uppercase italic tracking-tighter flex items-center justify-center space-x-3 hover:scale-105 transition-transform"
          >
            <span>Back to Safety</span>
          </Link>
          <Link 
            to="/explore" 
            className="px-8 py-4 bg-white/5 border border-white/10 text-white rounded-2xl font-black uppercase italic tracking-tighter flex items-center justify-center space-x-3 hover:bg-white/10 transition-colors"
          >
            <SafeIcon icon={FiCompass} className="w-4 h-4" />
            <span>Explore Builders</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;